import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Loader, tokens } from '@hotjar/hotsauce';
import { css } from '@emotion/react';
import { SignUpHeader } from '@hotjar/webapp/components/SignUpHeader';
import {
  Container,
  FormWrapper,
  RowWrapper,
  SideWrapper,
} from '@hotjar/webapp/features/Login/styles';
import { ValueProposition } from '../../Activation/ValueProposition';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
`;

const StyledLoader = styled(Loader)`
  margin: auto;
`;

export type RegisterLayoutProps = {
  children: ReactNode;
  className?: string;
  isLoading: boolean;
  user?: React.ComponentProps<typeof SignUpHeader>['user'];
};

export const RegisterLayout = ({
  children,
  isLoading,
  user,
  ...props
}: RegisterLayoutProps): JSX.Element => {
  return (
    <Wrapper {...props}>
      {isLoading ? (
        <StyledLoader size="xl" />
      ) : (
        <>
          <SignUpHeader user={user} />
          {children}
        </>
      )}
    </Wrapper>
  );
};

export const SplitRegisterLayout = ({
  children,
  isLoading,
  user,
  ...props
}: RegisterLayoutProps): JSX.Element => {
  return (
    <Container {...props}>
      {isLoading ? (
        <StyledLoader size="xl" />
      ) : (
        <>
          <SignUpHeader user={user} />
          <RowWrapper>
            <FormWrapper>{children}</FormWrapper>
            <SideWrapper
              css={css`
                background: ${tokens.BRAND_COLORS.cobalt_200};
              `}
            >
              <ValueProposition />
            </SideWrapper>
          </RowWrapper>
        </>
      )}
    </Container>
  );
};
